import { Box, BoxProps, Card, CardContent, Container, Skeleton } from '@mui/material';
import React from 'react';
import AppBar from '../app-bar/AppBar';
import BackLink from '../back-link/BackLink';
import Breadcrumbs from '../breadcrumbs/Breadcrumbs';

const Paragraph = (props: BoxProps) => (
  <Box {...props}>
    <Skeleton sx={{ width: 'calc(535/608*100%)' }} />
    <Skeleton sx={{ width: 'calc(590/608*100%)' }} />
    <Skeleton sx={{ width: 'calc(502/608*100%)' }} />
    <Skeleton sx={{ width: 'calc(470/608*100%)' }} />
    <Skeleton sx={{ width: 'calc(608/608*100%)' }} />
  </Box>
);

const ExerciseSkeleton = () => (
  <>
    <AppBar title="Exercise" />
    <Breadcrumbs
      items={[{ label: 'Home', to: '/' }, { label: <Skeleton width={160} /> }]}
      sx={{ display: { xs: 'none', sm: 'flex' } }}
    />
    <Container sx={{ my: 4 }}>
      <BackLink to="/" label="Back to Home" sx={{ display: { xs: 'inline-block', sm: 'none' }, my: 2 }} />
      <Skeleton height={184} variant="rectangular" sx={{ mb: 4 }} />

      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Skeleton sx={{ fontSize: '2rem' }} width={185} />
        <Skeleton sx={{ fontSize: '3rem' }} variant="rounded" width={167} />
      </Box>

      <Box>
        <Skeleton sx={{ fontSize: '3rem' }} width={'calc(578/1096*100%)'} />
        <Skeleton sx={{}} width={232} />
      </Box>

      <Box display="flex" gap={2} sx={{ fontSize: '1.5rem', mt: 6, width: 496 }}>
        <Skeleton sx={{ flex: 1 }} />
        <Skeleton sx={{ flex: 1 }} />
        <Skeleton sx={{ flex: 1 }} />
      </Box>

      <Box sx={{ display: { sm: 'grid' }, gridTemplateColumns: '6fr minmax(0, 4fr)', gap: 11 }}>
        <Box>
          <Paragraph my={4} />
          <Box mb={4}>
            <Skeleton width={197} sx={{ fontSize: '1.5rem' }} />
            <Skeleton height={139} variant="rectangular" />
          </Box>
          <Paragraph mb={4} />
          <Paragraph />
        </Box>
        <Box>
          <Card sx={{ mb: 2 }}>
            <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Skeleton sx={{ fontSize: '2rem' }} />
              <Skeleton height={104} variant="rectangular" />
              <Skeleton height={56} width="calc(259/400*100%)" variant="rectangular" />
              <Skeleton height={56} width="calc(327/400*100%)" variant="rectangular" />
              <Skeleton height={56} variant="rectangular" />
            </CardContent>
          </Card>
          <Card>
            <CardContent sx={{ display: 'flex', gap: 2 }}>
              <Skeleton height={70} width={70} variant="rectangular" />
              <Skeleton height={70} sx={{ flex: 1 }} variant="rectangular" />
            </CardContent>
          </Card>
        </Box>
      </Box>
    </Container>
  </>
);

export default ExerciseSkeleton;
